import { STENCIL_MODES } from '../shared/state/const.mjs';

"use strict";
class GlRenderTarget {
  constructor() {
    this.width = -1;
    this.height = -1;
    this.msaa = false;
    /**
     * Tracks which mip level is currently attached to this render target's framebuffer.
     * This lets us skip redundant framebufferTexture2D calls on the common path.
     * @internal
     */
    this._attachedMipLevel = 0;
    /**
     * Tracks which array layer (or cube face index) is currently attached to this render target's framebuffer.
     * For non-array 2D textures this will always be 0.
     * @internal
     */
    this._attachedLayer = 0;
    this.msaaRenderBuffer = [];
    /**
     * The stencil state the stencil system and the mask pipe track for this target on this renderer.
     * It lives here rather than in a uid-keyed record so it is restored when the target is bound again
     * and freed with the backend object when the target dies.
     */
    this.stencilMode = STENCIL_MODES.DISABLED;
    /** the stencil reference value that goes with `stencilMode` */
    this.stencilReference = 0;
    /** how many stencil masks are currently pushed on this target */
    this.maskStackIndex = 0;
  }
}

export { GlRenderTarget };
//# sourceMappingURL=GlRenderTarget.mjs.map
